import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { RdsIconLink, RdsTextLink } from '../core/models/index';
import { RdsApiService } from '../core/services/index';

/**
 * Toolbar with logo and configurable links
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Component({
  selector: 'rds-app-toolbar',
  template: `
    <mat-toolbar class="mat-elevation-z4">
      <img [attr.src]="rdsLogo" />
      <h1>{{ title }}</h1>
      <span fxFlex></span>
      <a *ngFor="let link of textLinks" mat-button [attr.href]="link.url" [attr.target]="link.target || '_blank'">{{
        link.text | uppercase
      }}</a>
      <mat-divider *ngIf="textLinks?.length" [vertical]="true"></mat-divider>
      <a
        *ngFor="let socialLink of socialLinks"
        mat-icon-button
        [attr.aria-label]="socialLink.text"
        [attr.href]="socialLink.url"
        [attr.target]="socialLink.target || '_blank'"
      >
        <mat-icon *ngIf="socialLink.icon; else textFallback" [svgIcon]="socialLink.icon"></mat-icon>
        <ng-template #textFallback>{{ socialLink.text }}</ng-template>
      </a>
    </mat-toolbar>
  `,
  styleUrls: ['./app-toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsAppToolbarComponent {
  /** Path to the rds logo, used as <img> src attribute */
  @Input() rdsLogo: string;
  /** Title text displayed next to the logo */
  @Input() title: string;

  /** Text based links */
  textLinks: Array<RdsTextLink> | null = this.rdsApiService.getConfig('toolbarTextLinks');
  /** Icon based social media links */
  socialLinks: Array<RdsIconLink> | null = this.rdsApiService.getConfig('toolbarSocialLinks');

  constructor(private rdsApiService: RdsApiService) {}
}
